import React, { useRef } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

export const DeleteRangeTooltip = (props) => {
  const { show, tooltip, children } = props || {};
  const ref = useRef(null);

  if (!props.children) return null;

  return <div ref={ref}>
    <OverlayTrigger
      placement="right"
      show={show}
      overlay={<Popover id="tooltip-contained">
        <Popover.Body className="f-small">
          {tooltip}
        </Popover.Body>
      </Popover>
      }
      container={ref}
    >
      {children}
    </OverlayTrigger>
  </div>
}
